import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { translate } from "app/filters/i18nFilter";
import { COMMA_MMM_D_YYYY } from "app/services/date-time/formats";
import { StyledDomainNameAndIcon, StyledFormattedDateCell } from "../../../components/tooltips/shared/styles";
import type TooltipTableColumn from "../../../models/view/signals-tooltip/TooltipTableColumn";
import createSignalsTooltipTableColumn from "../base/toolipBaseColumnFactory";
import { TOOLTIP_COLUMN_DATE_NAME, TOOLTIP_COLUMN_TECHNOLOGY_NAME } from "./const";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

type FactoryDeps = {
    parentColumnName: string;
};

export default function createTooltipColumnsResolver({ parentColumnName }: FactoryDeps) {
    const COLUMN_DISPLAY_NAME_KEY = "si.signals.table-columns.tooltip.table.column";

    return {
        getTableColumns(): TooltipTableColumn[] {
            return [
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_TECHNOLOGY_NAME,
                    displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.technologyName`),
                    maxWidth: 210,
                    cellComponent: ({
                        row,
                        value,
                    }: Omit<ITableCellProps, "value"> & { value: string; row: { id: number } }) => {
                        return (
                            <StyledDomainNameAndIcon
                                domain={value}
                                icon={salesSettingsHelper.getTechnographicsLink(row.id)}
                                data-automation-cell-value={value}
                            />
                        );
                    },
                }),
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_DATE_NAME,
                    displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.date-${parentColumnName}`),
                    cellComponent: (props: ITableCellProps) => {
                        return (
                            <StyledFormattedDateCell
                                {...props}
                                dateFormat={COMMA_MMM_D_YYYY}
                            />
                        );
                    },
                }),
            ];
        },
    };
}
